/**
 * This module is meant to provide mutations which
 * will be stored using the persisting store or the transient store
 * based on a fixed decision, e.g. web or mobile app context
 * @type {string}
 */
import store from '@/core/services/store/index';
import persistentStore from '@/core/services/store/persistent';
import {
  SET_SEARCH_PARAMS as SET_SEARCH_PARAMS_STORE,
  SET_GEOLOCATION_PERMISSION_DECLINED as SET_GEOLOCATION_PERMISSION_DECLINED_STORE,
  SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED as SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED_STORE
} from '@/core/services/store/search.module';
import appParameters, {
  CONTEXT_WEBSITE,
  CONTEXT_MOBILE_APP
} from '@/core/config/parameters';

const { APP_CONTEXT } = appParameters;

// setters names
export const SET_SEARCH_PARAMS = 'setSearchParams';
export const SET_GEOLOCATION_PERMISSION_DECLINED = 'setGeolocationPermissionDeclined';
export const SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED = 'setLargeUserDistanceWarningAcknowledged';

// getters names
export const GET_SEARCH_PARAMS = 'getSearchParams';
export const GET_GEOLOCATION_PERMISSION_DECLINED = 'getGeolocationPermissionDeclined';
export const GET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED = 'getLargeUserDistanceWarningAcknowledged';

const PersistentStoreProxyService = {

  [SET_SEARCH_PARAMS](searchParams) {
    if (APP_CONTEXT === CONTEXT_MOBILE_APP) {
      // use transient store for the mobile app
      store.commit(SET_SEARCH_PARAMS_STORE, searchParams);
    } else {
      // use permanent store for the website
      // as long as we have a monolithic web page and depend on a page reload between
      // homepage search bar and result listing (classic store works for SPA only)
      persistentStore.commit(SET_SEARCH_PARAMS_STORE, searchParams);
    }
  },

  [GET_SEARCH_PARAMS]() {
    if (APP_CONTEXT === CONTEXT_MOBILE_APP) {
      // use classic store for the mobile app
      return store.state.search.searchParams;
    } else {
      // use permanent store for the website
      // as long as we have a monolithic web page and depend on a page reload between
      // homepage search bar and result listing (classic store works for SPA only)
      return persistentStore.state.search.searchParams;
    }
  },

  [SET_GEOLOCATION_PERMISSION_DECLINED](isDeclined) {
    if (APP_CONTEXT === CONTEXT_MOBILE_APP) {
      store.commit(SET_GEOLOCATION_PERMISSION_DECLINED_STORE, isDeclined);
    } else {
      persistentStore.commit(SET_GEOLOCATION_PERMISSION_DECLINED_STORE, isDeclined);
    }
  },

  [GET_GEOLOCATION_PERMISSION_DECLINED]() {
    if (APP_CONTEXT === CONTEXT_MOBILE_APP) {
      return store.state.search.geolocationPermissionDeclined === true;
    } else {
      return persistentStore.state.search.geolocationPermissionDeclined === true;
    }
  },

  [SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED](isAcknowledged) {
    if (APP_CONTEXT === CONTEXT_MOBILE_APP) {
      store.commit(SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED_STORE, isAcknowledged);
    } else {
      persistentStore.commit(SET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED_STORE, isAcknowledged);
    }
  },

  [GET_LARGE_USER_DISTANCE_WARNING_ACKNOWLEDGED]() {
    if (APP_CONTEXT === CONTEXT_MOBILE_APP) {
      return store.state.search.largeUserDistanceWarningAcknowledged === true;
    } else {
      return persistentStore.state.search.largeUserDistanceWarningAcknowledged === true;
    }
  },

};

export default PersistentStoreProxyService;
